import React from 'react';
import { Breadcrumbs } from '@src/abyss/web/ui/Breadcrumbs';
import { RouteUrl } from '@src/common/util/routeUrl';

export const LinkAnalysisBreadcrumbs = () => {
  return (
    <Breadcrumbs
      items={[
        { title: 'Home', href: '/' },
        { title: 'Link Analysis', href: RouteUrl.linkAnalysis },
      ]}
    />
  );
};
